import { NgModule } from '@angular/core';
import { AclPermissionDirective } from './acl-permission.directive';

@NgModule({
  declarations: [AclPermissionDirective],
  exports: [AclPermissionDirective],
})
export class AclPermissionModule {}
